import {Form, Button} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "@heroui/modal";

const ResumeModal = ({campaign, dismissModal}) => {
  const submitResume = async () => {
    // Do validations
    const d = await fetch(`/api/v1/campaign/${campaign._id}/resume`, {method: 'PUT'});
    if (d?.status !== 200) {
      alert('Error resuming campaign: ' + d?.error);
    } else {
      alert('Campaign resumed successfully.');
      window.location.href = '/';
    }
  };

  return (
    <Form onSubmit={submitResume}>
      <Modal placement='top' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={dismissModal}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>
            Resume campaign "{campaign.subject}"?
          </ModalHeader>
          <ModalBody>
            <div style={{position: 'absolute', bottom: '15px', right: '102px'}}>
              <Button type='cancel' size='sm' onPress={() => dismissModal()}>Cancel</Button>
            </div>
            <div style={{position: 'absolute', bottom: '15px', right: '22px'}}>
              <Button type='submit' size='sm' onPress={() => submitResume()}>Resume</Button>
            </div>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Form>
  );
}

export default ResumeModal;
